export default __webpack_public_path__ + "static/media/img-checked.952bfb23.svg";